import React, { useState, useEffect } from "react";
import {
    Table,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    TextField,
    InputAdornment,
    IconButton,
    Menu,
    Typography,
    Button,
    Tooltip,
    Modal,
    Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Topbar from "../../admin/layouts/Topbar";
import Addproduct from "../../admin/components/Add_product";
import CircularProgress from "@mui/material/CircularProgress";
import instance from "../../utils/Api";
import Statusproduct from "../../admin/components/Status_product";
import { useGlobalContext } from "../../Contex"; // Adjust the path
import edit from '../../superadmin/assets/icons/add-icon.svg';
import { useNavigate, useSearchParams } from "react-router-dom";
import AddSection from "../components/Add_section";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Addstudent from "../components/Add_student";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from "react-toastify";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Students = () => {
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { openStatusDialog, setOpenStatusDialog } = useGlobalContext(); //status popup
    const { loading, setLoading } = useGlobalContext(); // State to handle loading
    const { anchorEl, setAnchorEl } = useGlobalContext(); //filter
    const { searchTerm, setSearchTerm } = useGlobalContext(); //search state
    const open = Boolean(anchorEl);
    const [page, setPage] = useState(0);
    const rowsPerPage = 10; // Fixed rows per page
    const startIndex = page * rowsPerPage; // Calculate the start and end index for pagination
    const [products, setProducts] = useState([]);
    const [addproducts, setAddproducts] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const classesDetail = searchParams.get('classId');
    const sectionId = searchParams.get('sectionId');
    const classname = searchParams.get('classname');
    const [data, setData] = useState();
    const [openmodel, setOpenModel] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const handleOpen = () => setOpenModel(true);
    const handleClose = () => { setOpenModel(false); setExcelData([]); };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file && file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            const reader = new FileReader();
            reader.onload = (event) => {
                const workbook = XLSX.read(event.target.result, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                // Filter out rows that are completely empty or invalid
                const formattedData = data.slice(1).map((row) => ({
                    rollno: row[0]?.toString().trim(),
                    name: row[1]?.toString().trim(),
                    whatsappNumber: row[2]?.toString().trim(),
                    gender: row[3]?.toString().trim(),
                    fatherName: row[4]?.toString().trim(),
                })).filter((row) => row.rollno && row.name && row.whatsappNumber);

                setExcelData(formattedData);
            };
            reader.readAsBinaryString(file);
        } else {
            toast.error("Please upload a valid Excel file!");
        }
    };

    console.log(excelData);

    const handleAddStudents = async () => {

        setButtonDisabled(true);
        try {
            const response = await instance.post('/api/v1/newrouts/addStudent', { students: excelData, sectionId: sectionId, classId: classesDetail });
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                // setAddstudents(true);// Trigger refresh after create schools
                setButtonDisabled(false);
                fetchProducts();
                setExcelData([]);
            } else {
                toast.error(response.data.message);
                setButtonDisabled(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log(error.response);
            setButtonDisabled(false);
        }
    }

    // Handle search
    const filteredProducts = products.filter((product) => {
        const searchTermLower = searchTerm.toLowerCase(); // Ensure searchTerm is always a string
        return (
            product?.name?.toLowerCase().includes(searchTermLower)
            //   product?.unit?.toLowerCase().includes(searchTermLower)
            // product?.status?.toLowerCase().includes(searchTermLower)
            // product?.age_limit?.toString().includes(searchTermLower)||
        );
    });

    //handle change
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Adjust to be 1-based
    };

    // Data slicing based on current page and rowsPerPage
    const paginatedproducts = filteredProducts.slice(
        page * rowsPerPage,
        (page + 1) * rowsPerPage
    );

    //filter function open menu
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };

    //filter function close menu
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const handleDownloadSample = () => {
        // Define the data and headings for the Excel file
        const data = [
            ['rollno', 'name', 'whatsappNumber', 'gender', 'fatherName'], // Header row
        ];

        // Convert the data into a worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sample Data');

        // Write the workbook and trigger a download
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        // Save the file using FileSaver
        const blob = new Blob([excelBuffer], {
            type: 'application/octet-stream',
        });
        saveAs(blob, 'Sample_Bulk_Add_Document.xlsx');
    };

    //fetch products
    const fetchProducts = async () => {
        try {
            let response;
            if (sectionId) {
                response = await instance.get(`/api/v1/newrouts/getSectionbyId?id=${sectionId}`);
                setProducts(response.data.data.students);
                setData(response.data.data);
            } else {
                response = await instance.get("/api/v1/newrouts/getClasses");
                setProducts(response.data.data);
            }
            // setProducts(response.data.data);
        } catch (error) {
            console.error("Error fetching Products:", error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
        setAddproducts(false); // Reset after fetching
        setLoading(true);
        setPage(0);
    }, [addproducts, sectionId]);

    // Function to handle opening the popup for adding new admin
    const handleAddClick = () => {
        setSelectedProduct(null); // Clear selected admin (add new mode)
        setOpenDialog(true); // Open the popup
    };
    const handleAddsectionClick = () => {
        setSelectedProduct(null); // Clear selected admin (add new mode)
        setOpenStatusDialog(true); // Open the popup
    };

    const handleEditClick = (product) => {
        setSelectedProduct(product);
        setOpenStatusDialog(true);
    }
    const handleEditsectionClick = (product) => {
        setSelectedProduct(product);
        setOpenStatusDialog(true);
    }

    // Function to handle status click and open the popup
    const handleStatusClick = (product) => {
        setSelectedProduct(product); // Store the selected product
        setOpenStatusDialog(true); // Open the popup
    };

    return (
        <React.Fragment>
            <Topbar />
            {loading ? (
                <div className="loading">
                    <CircularProgress />
                </div>
            ) : (
                <section className="main">
                    <div className="employees-text">
                        <Typography variant="h5">{`(${classname} - ${data?.name} Section) Students`}</Typography>
                        <div className="back_buttons">
                            <Button variant="outlined" onClick={() => navigate(-1)}>
                                <ArrowBackIcon /> Back
                            </Button>
                            <Button variant="outlined" onClick={handleDownloadSample} >
                                Sample Bulk Add Document
                            </Button>
                            <Button variant="outlined" onClick={handleOpen} >
                                Add Bulk Student
                            </Button>
                            <Button variant="outlined" onClick={handleAddsectionClick} >
                                Add Student
                            </Button>
                        </div>
                    </div>
                    <div className="employees-main">
                        <div className="employees-content ">
                            <div className="search-options">
                                <TextField
                                    placeholder="Search"
                                    type="search"
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(0);
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="pagination-options table-pagination">
                                <div className="pagination-animation"></div>
                                <TablePagination
                                    component="div"
                                    count={filteredProducts?.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page} // Adjust to be 0-based for MUI TablePagination
                                    onPageChange={handleChangePage}
                                    rowsPerPageOptions={[]}
                                    labelDisplayedRows={({ from, to, count }) =>
                                        `${from} to ${to} of ${count !== -1 ? count : `more than ${to}`
                                        }`
                                    }
                                />
                            </div>
                        </div>
                        <div className="employee-table">
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <div className="employee-name">S.NO</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Roll Number</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Student Name</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Gender</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Father Name</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Whatsapp Number</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Action</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedproducts.length > 0 ? (
                                            paginatedproducts.map((product, index) => (
                                                <TableRow abIndex={-1} key={product._id}>
                                                    <TableCell component="th" scope="row">
                                                        {startIndex + index + 1}
                                                    </TableCell>
                                                    <TableCell align="left">{product?.rollno}</TableCell>
                                                    <TableCell align="left">{product?.name}</TableCell>
                                                    <TableCell align="left">{product?.gender}</TableCell>
                                                    <TableCell align="left">{product?.fatherName}</TableCell>
                                                    <TableCell align="left">{product?.whatsappNumber}</TableCell>
                                                    <TableCell align="left">
                                                        <span
                                                            className="view"
                                                            onClick={() =>handleEditClick(product)}
                                                        >
                                                            <Tooltip title="Update Student">
                                                                <img src={edit} alt="edit" />
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center">
                                                    <Typography>No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </section>
            )
            }
            {/* <Addstudent
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                setAddproducts={setAddproducts}
                selectedProduct={selectedProduct}
                onProductUpdate={fetchProducts}
            /> */}
            <Addstudent
                openDialog={openStatusDialog}
                setOpenDialog={setOpenStatusDialog}
                setAddproducts={setAddproducts}
                selectedProduct={selectedProduct}
                onProductUpdate={fetchProducts}
                sectionId={sectionId}
                classesDetail={classesDetail}
            />
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openmodel}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Bulk Upload
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Upload Student Excel File
                    </Typography>
                    <input
                        type="file"
                        accept=".xlsx"
                        onChange={handleFileUpload}
                        style={{ marginBottom: 20 }}
                    />
                    {excelData.length > 0 && (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Roll No</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>WhatsApp Number</TableCell>
                                    <TableCell>Gender</TableCell>
                                    <TableCell>Father Name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {excelData.map((student, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{student.rollno}</TableCell>
                                        <TableCell>{student.name}</TableCell>
                                        <TableCell>{student.whatsappNumber}</TableCell>
                                        <TableCell>{student.gender}</TableCell>
                                        <TableCell>{student.fatherName}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        className="add-btn"
                        onClick={handleAddStudents}
                        disabled={buttonDisabled}
                    >
                        Add
                    </Button>
                </DialogActions>
            </BootstrapDialog>
            {/* <Statusproduct
                open={openStatusDialog}
                handleClose={() => setOpenStatusDialog(false)}
                product={selectedProduct}
                setAddproducts={setAddproducts}
            /> */}
        </React.Fragment >
    );
};

export default Students;
